import en from "./en";
import es from "./es";
import it from "./it";
import fr from "./fr";
import de from "./de";
import pt from "./pt";

const messages = { en, es, it, fr, de, pt } as const;

export type Locale = keyof typeof messages;
export type MessageKey = keyof typeof en;
export default messages;
